<template>
  <common-dialog ref="dialog" :title="title" width="700px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column label="班级" min-width="120px">
        <template slot-scope="{row}">
          <span>高{{getGrade(row.GradeSn)}}（{{row.ClassSn}}）班</span>
        </template>
      </el-table-column>
      <el-table-column label="IP" prop="Ip" />
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/at/device").default,
      data: [],
      params: {},
      title: "导出 考勤设备信息",
    };
  },
  methods: {
    getData(params) {
      this.params = params;
      this.$refs.dialog.isLoading = true;
      this.api.list(params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    getGrade(GradeSn) {
      var grade_sn = "一";
      switch (GradeSn) {
        case 1:
          grade_sn = "一";
          break;
        case 2:
          grade_sn = "二";
          break;
        case 3:
          grade_sn = "三";
          break;
      }
      return grade_sn;
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>